import { Link } from 'react-router-dom'
import { Building2, Folder } from 'lucide-react'
import { countDescendantAreas } from '@/lib/areaTree'
import type { AreaNode } from '@/lib/types/ged'

type Props = {
  nodes: AreaNode[]
  /** true nos cards do Índice (nível 1) — usa ícone de prédio em vez de pasta. */
  topLevel?: boolean
}

export function AreaCardsGrid({ nodes, topLevel = false }: Props) {
  if (nodes.length === 0) {
    return <p style={{ color: 'var(--ev-fg-muted)', fontSize: 'var(--fs-body)' }}>Nenhuma área disponível.</p>
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16 }}>
      {nodes.map((node) => (
        <AreaCard key={node.id} node={node} topLevel={topLevel} />
      ))}
    </div>
  )
}

function AreaCard({ node, topLevel }: { node: AreaNode; topLevel: boolean }) {
  const Icon = topLevel ? Building2 : Folder
  const subAreaCount = countDescendantAreas(node)

  return (
    <Link to={`/areas/${node.slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
      <div
        style={{
          background: 'var(--ev-bg-elevated)',
          border: '1px solid var(--ev-border)',
          borderRadius: 10,
          padding: 20,
          height: '100%',
          cursor: 'pointer',
        }}
      >
        <div
          style={{
            width: 40, height: 40, borderRadius: 8,
            background: 'var(--ev-accent-soft)', color: 'var(--ev-accent)',
            display: 'grid', placeItems: 'center', marginBottom: 12,
          }}
        >
          <Icon size={20} />
        </div>
        <div style={{ fontSize: 'var(--fs-body-lg)', fontWeight: 600, color: 'var(--ev-fg-strong)', marginBottom: 6 }}>
          {node.name}
        </div>
        {node.description && (
          <p style={{ fontSize: 'var(--fs-small)', color: 'var(--ev-fg-muted)', marginBottom: 12, lineHeight: 1.4 }}>
            {node.description}
          </p>
        )}
        <div style={{ fontSize: 'var(--fs-small)', color: 'var(--ev-fg-muted)' }}>
          {subAreaCount > 0 && `${subAreaCount} subáreas · `}
          {node.documentCount.toLocaleString('pt-BR')} arquivos
        </div>
      </div>
    </Link>
  )
}
